/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  UnauthorizedResponse,
  VarianceReport,
  VarianceReportResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary This endpoint is used to get Variance report of branch
 */
export const getVarianceReport = (varianceReport: VarianceReport) => {
  return customInstance<VarianceReportResponseResponse>({
    url: `/bm-declaration-service/v1/variance-report`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: varianceReport,
  });
};

export const getGetVarianceReportMutationOptions = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getVarianceReport>>,
    TError,
    { data: VarianceReport },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getVarianceReport>>,
  TError,
  { data: VarianceReport },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getVarianceReport>>,
    { data: VarianceReport }
  > = (props) => {
    const { data } = props ?? {};

    return getVarianceReport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetVarianceReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof getVarianceReport>>
>;
export type GetVarianceReportMutationBody = VarianceReport;
export type GetVarianceReportMutationError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary This endpoint is used to get Variance report of branch
 */
export const useGetVarianceReport = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getVarianceReport>>,
    TError,
    { data: VarianceReport },
    TContext
  >;
}) => {
  const mutationOptions = getGetVarianceReportMutationOptions(options);

  return useMutation(mutationOptions);
};
